export default "__VITE_ASSET__D9jI_7N8__"